// extracted by mini-css-extract-plugin
export default {"container":"styles_container__h-BkX","header":"styles_header__BJiGH","spinnerWrapper":"styles_spinnerWrapper__O55as","cardContainer":"styles_cardContainer__u5j5y"};